module.exports = __webpack_public_path__ + "img/discord_bot_large_canvas.d6b32b82.jpg";